// === editable fields ===
export const FIELD_A0 = 'angle';
export const FIELD_W1 = 'width_1';
export const FIELD_W2 = 'width_2';
export const FIELD_W3 = 'width_3';
export const FIELD_H1 = 'height_1';
export const FIELD_H2 = 'height_2';
export const FIELD_H3 = 'height_3';
export const FIELD_D1 = 'diameter_1';
export const FIELD_D2 = 'diameter_2';
export const FIELD_D3 = 'diameter_3';
export const FIELD_D4 = 'diameter_4';

/** real length of a duct fitting */
export const FIELD_L0 = 'length';
/** from EQUIPMENT symbol */
export const FIELD_ID = 'identifier';
/** from EQUIPMENT sybmol */
export const FIELD_ST = 'subtype';
/** from EQUIPMENT sybmol */
export const FIELD_SN = 's_number';
/** system field - @2025/04/03 */
export const FIELD_S0 = 'system';
/** zone field for all symbol - @2025/04/03 */
export const FIELD_Z0 = 'zone';
/** shape field */
export const FIELD_SP = 'shape';
/** text content field - @2025/10/08 */
export const FIELD_CT = 'content';
/** multiplier for equipment - @2025/10/17 */
export const FIELD_MP = 'multiplier';
/** name for equipment - @2025/10/20 */
export const FIELD_NM = 'name';
/** diffuser_code - @2026/04/27 */
export const FIELD_DF = 'diffuser_code';

// === read-only fields ===
export const LENGTH_FIELD = 'length_1';
export const LENGTH_STR_FIELD = 'length_unit_str';

export const USER_VALIDATED_FIELD = 'user_validated';
export const VERTICAL_LENGTH_FIELD = 'vertical_length'; // @2024/10/29

/** invisible fields  @2025/11/20 */
export const FIELD_HAS_EC = 'has_endcap';

/**
 * Indicate if DUCT_LENGTH use diagonal to calculate length
 * @2026/03/05
 */
export const FIELD_USE_DIAGONAL = 'use_diagonal';

/**
 * add `side_take_off` for duct length according to the issue:
 * https://taksoai.atlassian.net/browse/TAK-956
 *  @2026/04/28
 *
 * ### items including:
 * - CENTER_LINE_REDUCER
 * - ECCENTRIC_REDUCER
 */
export const FIELD_SIDE_TAKE_OFF = 'side_take_off';

/**
 * simillar to side_take_off but need create two for duct length:
 * @2026/05/28
 *
 * ### items including:
 * - DUCT_LENGTH;
 * - ...
 */
export const FIELD_ADD_STO = 'add_take_off';

/**
 * invisible field for side_takeoff and insulation
 * @2026/06/08
 *
 * ### items including:
 * - INSULATION_VIRT;
 * - SIDE_TAKEOFF;
 */
export const FIELD_PARENT_ID = 'parentId';

/** added in 2026/06/08 */
export const FIELD_PRODUCT_CODE = 'product_code';

/** for insulation items @2026/06/23 */
export const FIELD_HAS_INSULATION = 'has_insulation';

/**
 * for issue:
 * https://taksoai.atlassian.net/browse/TAK-1049
 *
 * Add an optional Cushion Box checkbox to grille items.
 * This allows users to identify when a cushion box is required without entering dimensions or other details.
 */
export const FIELD_HAS_CUSHION_BOX = 'has_cushion_box';
